module.exports = __webpack_public_path__ + "img/app-logo.6e00ec8c.svg";